var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1134 17.324L18 14.456L16.6392 13.104L15.3952 14.34L15.3952 3.65998L16.6392 4.89599L18 3.544L15.1134 0.675995L14.433 0L13.7526 0.675995L10.866 3.544L12.2268 4.89599L13.4708 3.65998L13.4708 14.34L12.2268 13.104L10.866 14.456L13.7526 17.324L14.433 18L15.1134 17.324ZM0.962201 3.26399C0.430792 3.26399 0 3.69201 0 4.21999C0 4.74798 0.430792 5.176 0.962201 5.176H7.69761C8.22902 5.176 8.65981 4.74798 8.65981 4.21999C8.65981 3.69201 8.22902 3.26399 7.69761 3.26399H0.962201ZM0.962201 8.044C0.430792 8.044 0 8.47202 0 9C0 9.52799 0.430792 9.956 0.962201 9.956H7.69761C8.22902 9.956 8.65981 9.52799 8.65981 9C8.65981 8.47202 8.22902 8.044 7.69761 8.044H0.962201ZM0 13.78C0 13.252 0.430792 12.824 0.962201 12.824H7.69761C8.22902 12.824 8.65981 13.252 8.65981 13.78C8.65981 14.308 8.22902 14.736 7.69761 14.736H0.962201C0.430792 14.736 0 14.308 0 13.78Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/SortIcon.d0f8e027.svg";
export { ForwardRef as ReactComponent };